module.exports = "pegasus/assets/rectangle-facebook.png";